import React from 'react'
import styled from 'styled-components'

const EventListStyle = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  padding-left: 0;
`

const DOWS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const isMidnight = (date) =>
  date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0

const formatEventTime = (start, end) => {
  const sDate = new Date(start)
  if (isMidnight(sDate)) {
    return null
  }

  const formatTime = (date) =>
    date
      .toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase()

  if (!end) {
    return formatTime(sDate)
  }

  const eDate = new Date(end)
  if (isMidnight(eDate)) {
    return formatTime(sDate)
  }

  if (sDate.toDateString() === eDate.toDateString()) {
    return `${formatTime(sDate)} - ${formatTime(eDate)}`
  }

  return formatTime(sDate)
}

const formatDate = (date) => {
  const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return {
    month: MONTHS[date.getMonth()],
    day: date.getDate(),
    dow: DOWS[date.getDay()],
  }
}

export const EventShortList = ({ list, count = 6 }) => {
  const isBoost = window.ASC_IS_BOOST

  const dateSort = (a, b) => {
    if (a.startTime < b.startTime) {
      return -1
    } else if (a.startTime > b.startTime) {
      return 1
    }
    return 0
  }

  const isFeatured = (cats) => {
    return cats.some((cat) => cat.slug === 'featured')
  }

  const sortFeatured = (a, b) => {
    if (isFeatured(a.categories) && !isFeatured(b.categories)) {
      return -1
    }
    return 0
  }

  const filterBySite = ({ hideOnJoy, hideOnBoost }) => {
    if (isBoost) {
      return !hideOnBoost
    } else {
      return !hideOnJoy
    }
  }

  const formatLongDates = (start, end) => {
    const sDate = new Date(start)
    const eDate = end ? new Date(end) : sDate
    const startDate = formatDate(sDate)
    const endDate = formatDate(eDate)

    if (sDate.getMonth() === eDate.getMonth()) {
      if (sDate.getDate() === eDate.getDate()) {
        return (
          <>
            <span className='dow'>{startDate.dow},</span>
            <span className='spacer'> </span>
            <span className='month'>{startDate.month}</span>
            <span className='spacer'> </span>
            <span className='day'>{startDate.day}</span>
          </>
        )
      } else {
        return (
          <>
            <span className='dow'>{startDate.dow},</span>
            <span className='spacer'> </span>
            <span className='month'>{startDate.month}</span>
            <span className='spacer'> </span>
            <span className='day'>{startDate.day}</span>
            <span className='dash'>-</span>
            <span className='spacer'> </span>
            <span className='dow'>{endDate.dow},</span>
            <span className='spacer'> </span>
            <span className='day'>{endDate.day}</span>
          </>
        )
      }
    } else {
      return (
        <>
          <span className='dow'>{startDate.dow},</span>
          <span className='spacer'> </span>
          <span className='month'>{startDate.month}</span>
          <span className='spacer'> </span>
          <span className='day'>{startDate.day}</span>
          <span className='dash'>-</span>
          <span className='spacer'> </span>
          <span className='dow'>{endDate.dow},</span>
          <span className='spacer'> </span>
          <span className='month'>{endDate.month}</span>
          <span className='day'>{endDate.day}</span>
        </>
      )
    }
  }

  const formatDates = (start, end) => {
    const sDate = new Date(start)
    const eDate = end ? new Date(end) : sDate
    const startDate = formatDate(sDate)
    const endDate = formatDate(eDate)

    if (sDate.getMonth() === eDate.getMonth()) {
      if (sDate.getDate() === eDate.getDate()) {
        return (
          <>
            <span className='month'>{startDate.month}</span>
            <span className='spacer'> </span>
            <span className='day'>{startDate.day}</span>
          </>
        )
      } else {
        return (
          <>
            <span className='month'>{startDate.month}</span>
            <span className='spacer'> </span>
            <span className='day'>{startDate.day}</span>
            <span className='dash'>-</span>
            <span className='day'>{endDate.day}</span>
          </>
        )
      }
    } else {
      return (
        <>
          <span className='month'>{startDate.month}</span>
          <span className='spacer'> </span>
          <span className='day'>{startDate.day}</span>
          <span className='dash'>-</span>
          <span className='month'>{endDate.month}</span>
          <span className='day'>{endDate.day}</span>
        </>
      )
    }
  }

  const formatFloatingDates = (start, end) => {
    const sDate = new Date(start)
    const eDate = end ? new Date(end) : sDate
    const startDate = formatDate(sDate)
    const endDate = formatDate(eDate)

    if (
      sDate.getMonth() !== eDate.getMonth() ||
      sDate.getDate() !== eDate.getDate()
    ) {
      return (
        <>
          <div className='start-date'>
            <span className='label'>From</span>
            <div className='date'>
              <span className='month'>{startDate.month}</span>
              <span className='day'>{startDate.day}</span>
            </div>
          </div>
          <div className='end-date'>
            <span className='label'>To</span>
            <div className='date'>
              <span className='month'>{endDate.month}</span>
              <span className='day'>{endDate.day}</span>
            </div>
          </div>
        </>
      )
    }
    return (
      <div className='date'>
        <span className='month'>{startDate.month}</span>
        <span className='day'>{startDate.day}</span>
      </div>
    )
  }

  return (
    <div>
      <EventListStyle className={`event-list-${list.id.toLowerCase()}`}>
        {list.events
          .filter(filterBySite)
          .sort(dateSort)
          .sort(sortFeatured)
          .slice(0, count)
          .map(
            ({
              title,
              startTime,
              endTime,
              description,
              eventLink,
              imageUrl,
              address,
              categories,
              locations = [],
              soldOut,
              hideTime,
            }) => {
              const eventTime = !hideTime && formatEventTime(startTime, endTime)

              return (
              <React.Fragment key={title}>
                {isBoost ? (
                  <div
                    className={`block list-item event-block column ${
                      imageUrl ? 'image-event-link ' : ''
                    }${
                      isFeatured(categories) ? 'featured-event ' : ''
                    }${soldOut ? 'sold-out ' : ''}${
                      hideTime ? 'hide-time ' : ''
                    }event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      {categories.length > 0 && (
                        <span className='category'>{categories[0].name}</span>
                      )}
                      <div className='long-date'>
                        {formatLongDates(startTime, endTime)}
                      </div>
                      {eventTime && (
                        <span className='event-time'>{eventTime}</span>
                      )}
                      <span className='title'>{title}</span>
                      {locations.length > 1 ? (
                        <span className='location'>Multiple Locations</span>
                      ) : (
                        locations.length > 0 && (
                          <span className='location'>{locations[0].name}</span>
                        )
                      )}
                      {address && <span className='address'>{address}</span>}
                      <p
                        className={
                          'excerpt' +
                          (description.length > 150 ? ' ellipsis' : '')
                        }
                        dangerouslySetInnerHTML={{
                          __html: description.substring(0, 150),
                        }}
                      />
                      <a href={eventLink} class='button'>
                        View Event Details
                      </a>
                    </div>
                    <div className='floating-dates'>
                      {formatFloatingDates(startTime, endTime)}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`block list-item ${
                      imageUrl ? 'image-event-link ' : ''
                    }${isFeatured(categories) ? 'featured ' : ''}${
                      soldOut ? 'sold-out ' : ''
                    }${hideTime ? 'hide-time ' : ''}event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      <span className='start-date'>
                        {formatDates(startTime, endTime)}
                        {eventTime && (
                          <>
                            <span className='spacer'> </span>
                            <span className='event-time'>{eventTime}</span>
                          </>
                        )}
                      </span>
                      <span className='title'>{title}</span>
                      <div
                        className='description'
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                      <a href={eventLink} className='link'>
                        Details
                      </a>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
            }
          )}
      </EventListStyle>
    </div>
  )
}
